import _ from 'lodash';

function EntrySelectCtrl($rootScope, $scope, $window, $state, $stateParams, $q, $timeout, toastr, PlanService, UserService, PlayerService, AppSettings, AppContextService) {
  'ngInject';

  /**
   * appContext.type.id, appContext.team.id 가 전달된다.
   */


  var vm = this;
  vm.appContext = AppContextService.context;

  // console.log('$stateParams', $stateParams);

  vm.entryMain = [];
  // console.log('vm.entryMain', vm.entryMain);
  vm.entryBackup = [];
  vm.entryType = 'main';

  var getEntry = function () {
    var functionName = $stateParams.type_code == 'game' ? 'getEntry' : 'getTrainingEntry';
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      // [$stateParams.type_code + '_id']: $stateParams.id,
      status: 'IN',
      is_oppo: $stateParams.team_code == 'oppo_team' ? 'Y' : 'N'
    };

    if ($stateParams.type_code === 'game') {
      data.game_id = $stateParams.id;      
    }

    if ($stateParams.type_code === 'training') {
      data.training_root_id = $stateParams.id;
      data.training_id = $stateParams.id;
    }

    // console.log('data >>>>>>>>>', data);
    // return;

    PlanService[functionName](data)
      .then(function (res) {
        // console.log('1111', res)

        vm.entryMain = res.data.players;
        vm.entryMainOld = angular.copy(vm.entryMain);

        if ($stateParams.type_code == 'game') {
          data.status = 'WAIT';
          return PlanService[functionName](data);
        } else {
          return;
        }
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
      .then(function (res) {
        vm.entryBackup = res.data.players;
        vm.entryBackupOld = angular.copy(vm.entryBackup);

      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
  };

  getEntry();

  vm.saveTraining = function () {
    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      // [$stateParams.type_code + '_id']: $stateParams.id,
      training_root_id: $stateParams.id,
      user_id: _.map(vm.entryMain, 'user_id').join(), // 훈련은 선택된 선수를 전송
      // status: 'OUT',
      // is_oppo: $stateParams.team_code == 'oppo_team' ? 'Y' : 'N'
    };

    PlanService.setTrainingEntry(data)
      .then(function (res) {
        window.history.back();
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })

  }

  vm.saveGame = function (team_id) {

    // console.log(vm.entryMainOld.length, vm.entryMain.length, vm.entryMain)
    // console.log('vm.entryMain 11111', vm.entryMain.length, JSON.stringify(vm.entryMain) )

    // console.log('AAAAAAA', vm.entryMain.length);


    // var limit = {
    //   position_name: 'GK', min : 1, max: 1,

    // }

    // var map = vm.entryMain.reduce(function (m, v) {
    //   for (var k in m) {
    //     if (~v.position_name.indexOf(k)) m[k]++;
    //   }
    //   return m;
    // }, { GK:0 });

    // if (map.GK !== 1) {
    //   toastr.error('GK는 1명이어야 합니다.');
    //   return;
    // }

    // DF, MF, FW : 각 최소2명, 최대 6명 이런 식으로 가능하실까요?

    var arr_GK = [];
    var arr_DF = [];
    var arr_MF = [];
    var arr_FW = [];

    // vm.entryMain
    _.forEach(vm.entryMain, function (item) { 
      // console.log(item)
      if (item.position_name.indexOf('GK')>-1) {
        arr_GK.push(item);
      }
      if (item.position_name.indexOf('DF') > -1) {
        arr_DF.push(item);
      }
      if (item.position_name.indexOf('MF') > -1) {
        arr_MF.push(item);
      }
      if (item.position_name.indexOf('FW') > -1) {
        arr_FW.push(item);
      }
    })

    console.log('arr_GK_lenght', arr_GK.length,);
    console.log('DF,MF,FW_lenght', arr_DF.length, arr_MF.length, arr_FW.length);


    if (arr_GK.length !== 1) {
      toastr.error('GK는 1명이어야 합니다.');
      return;
    }

    if (vm.entryMain.length < 2) {
      toastr.error('출전선수는 2명 이상이 있어야 합니다.');
      return;
    }

    if (vm.entryMain.length > 11) {
      toastr.error('출전선수는 11명을 초과할 수 없습니다.');
      return;
    }

    var functionName = $stateParams.type_code == 'game' ? 'setEntry' : 'setTrainingEntry';

    if ($stateParams.team_code == 'oppo_team') {
      vm.appContext.team_id = team_id;
    }

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      [$stateParams.type_code + '_id']: $stateParams.id,
      user_id: _.map(vm.entryMainOld, 'user_id').join(), // 주전삭제
      status: 'OUT',
      is_oppo: $stateParams.team_code == 'oppo_team' ? 'Y' : 'N'
    };


    PlanService[functionName](data)
      .then(function (res) {
        data.user_id = _.map(vm.entryBackupOld, 'user_id').join(); // 후보삭제
        data.status = 'OUT'
        return PlanService[functionName](data);
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
      .then(function (res) {
        // console.log('vm.entryMain 22222', vm.entryMain.length, JSON.stringify(vm.entryMain))
        
        data.user_id = _.map(vm.entryMain, 'user_id').join();
        data.status = 'IN';

        console.log('출전선수 명 : ', _.map(vm.entryMain, 'user_id').length)

        return PlanService[functionName](data);
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
      .then(function (res) {
        data.user_id = _.map(vm.entryBackup, 'user_id').join();
        data.status = 'WAIT'
        return PlanService[functionName](data);
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })
      .then(function (res) {
        window.history.back();
      })
      .catch(function (error) {
        console.log("An error occured : " + error);
      })

  }

  vm.copyToEntry = function (player) {
    // console.log('vm.entryMain', vm.entryMain);

    // type불일치하여 Number로 변환필요
    if (_.find(vm.entryMain, { user_id: player.user_id })) {
      toastr.error('이미 Entry에 등록되어 있습니다.');
      return;
    }
    if (_.find(vm.entryBackup, { user_id: player.user_id })) {
      toastr.error('이미 Entry에 등록되어 있습니다.');
      return;
    }

    if (vm.entryType === 'main') {
      vm.entryMain.push(player);
    }

    if (vm.entryType === 'backup') {
      vm.entryBackup.push(player);
    }
  }

  vm.cancel = function () {
    window.history.back();
  }

  vm.remove = function (players, player) {
    _.remove(players, player);
  }

  vm.switch = function () {
    if (!vm.switchPlayerMain || !vm.switchPlayerBackup) {
      toastr.error('주전선수와 후보선수를 선택하세요.');
      return;
    }
    _.remove(vm.entryMain, JSON.parse(vm.switchPlayerMain))
    vm.entryBackup.push(JSON.parse(vm.switchPlayerMain))
    _.remove(vm.entryBackup, JSON.parse(vm.switchPlayerBackup))
    vm.entryMain.push(JSON.parse(vm.switchPlayerBackup))
  }

  var getUserList = function() {
    let params = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      limit: 100,
      page: 1,
      team_id: $stateParams.team_id,
      step2: 'Y'
    };
    
    UserService.getUserList(params).then(function (res) {
      // vm.playersAll = res.data.list;
    });

    PlayerService.getPlayers(params).then(function(res) {
      vm.playersAll = res.data.players;
    })

  }
    
  getUserList();

}

export default {
  name: 'EntrySelectCtrl',
  fn: EntrySelectCtrl
};
